module.exports = __webpack_public_path__ + "static/Q7Answer4_Spa_mark_christian_killick_calver-e5e2109f4bc93093c5745371d3e9a344.jpg";